import React from 'react';
import { call, takeEvery } from 'redux-saga/effects';
import UpdatedToast from '@/components/toasts/UpdatedToast';
import showToast from '@/utils/toasts';
import ErrorsToast from '@/components/toasts/ErrorsToast';
import DeletesToast from '@/components/toasts/DeletesToast';
import actions from '../constants';
import CollectionCreatedToast from '../components/CollectionCreatedToast';

export function* updateCollectionToast({ result }) {
  yield call(showToast, <UpdatedToast code={result.code} name={result.name} />);
}

export function* newCollectionToast({ result }) {
  yield call(showToast, <CollectionCreatedToast code={result.code} name={result.name} />);
}

export function* destroyCollectionToast({ items, silent }) {
  if (!silent) {
    yield call(showToast, <DeletesToast items={items} />);
  }
}

export function* destroyCollectionErrorToast({ items }) {
  yield call(showToast, <ErrorsToast operation="actions.delete" errors={items} />);
}

export default function* collectionsToasts() {
  yield takeEvery(actions.NEW_COLLECTION, newCollectionToast);
  yield takeEvery(actions.UPDATE_COLLECTION_SUCCESS, updateCollectionToast);
  yield takeEvery(actions.DESTROY_COLLECTION, destroyCollectionToast);
  yield takeEvery(actions.DESTROY_COLLECTION_ERROR, destroyCollectionErrorToast);
}
